export default {"src":"/_next/static/media/multitrack.9500ba08.svg","height":45,"width":55,"blurWidth":0,"blurHeight":0};